// extracted by mini-css-extract-plugin
export var backgroundContainer = "index-module--backgroundContainer--rscUS";
export var card = "index-module--card--mAtV5";
export var cardContainer = "index-module--cardContainer--QzH+s";
export var container = "index-module--container--OasUo";
export var description = "index-module--description--NdDvq";